import styled from 'styled-components'

export const Text = styled.span`
  font-size: 12px;
  line-height: 16px;
`

export const Container = styled.div<{
  forSku?: boolean,
  forCart?:boolean,
  forCheckout?: boolean,
  forPlp?: boolean,
  forAccount?: boolean,
  hasStrikePrice?:boolean
 }>`
  display: flex;
  position: absolute;
  background: #fff;
  z-index: 11;
  height: auto;
  border-radius: 4px;
  padding: 16px;
  bottom: ${props => (props?.forSku && !props?.hasStrikePrice ? '50px' : '33px')};
  width: calc(100% - 32px);
  max-width: 320px;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.32);

  @media (max-width: 369px) {
    bottom: ${props => (props?.forSku && (props?.hasStrikePrice ? '40px' : '44px')) || '33px'};
  }

  @media (min-width: 370px) and (max-width: 992px) {
    bottom: ${props => (props?.forSku && (props?.hasStrikePrice ? '42px' : '52px')) || '33px'};
  }

  @media screen and (max-width: 320px) {
    ${props => (props?.forCheckout || props?.forAccount ? 'min-width: unset' : 'min-width: 272px')};
    ${props => (props?.forPlp || props?.forCart ? 'left: -130px;' : '')}
  }

  @media screen and (min-width: 321px) and (max-width: 374px) {
    ${props => (props?.forCheckout || props?.forAccount ? 'min-width: unset' : 'min-width: 272px')};
    ${props => (props?.forPlp ? 'left: -108px;' : '')}
    ${props => (props?.forCart ? 'left: -130px;' : '')}
  }

  @media screen and (min-width: 375px) and (max-width: 480px) {
    ${props => (props?.forCheckout || props?.forAccount ? 'min-width: unset' : 'min-width: 272px')};
    ${props => (props?.forPlp ? 'left: -92px;' : '')}
    ${props => (props?.forCart ? 'left: -108px;' : '')}
  }

  @media screen and (min-width: 481px) and (max-width: 680px) {
    min-width: 272px;
    ${props => (props?.forPlp || props?.forCart ? 'left: -42px;' : '')}
  }

  @media (min-width: 993px) and (max-width: 1239px) {
    width: ${props => (props?.forPlp ? '208px' : '300px')};
    max-width: ${props => (props?.forPlp ? '208px' : '300px')};
    min-width: ${props => (props?.forPlp ? '208px' : '300px')};
    ${props => (props?.forSku || props?.forCart ? 'left: 50px;' : '')}
  }

  @media (min-width: 1240px) {
    ${props => (props?.forSku ? 'width: 300px;' : '')};
    ${props => (props?.forSku ? 'max-width: 300px;' : '')};
    ${props => (props?.forSku ? 'min-width: 300px' : '')};
    ${props => (props?.forSku ? 'left: 150px;' : '')}
  }
`
